import { render, staticRenderFns } from "./NonCompliantEventsLast7Days.vue?vue&type=template&id=854c776e&"
import script from "./NonCompliantEventsLast7Days.vue?vue&type=script&lang=ts&"
export * from "./NonCompliantEventsLast7Days.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports